/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetRudoFoldersQueryResponse, SocialExportGetRudoFoldersPathParams, SocialExportGetRudoFolders400, SocialExportGetRudoFolders401, SocialExportGetRudoFolders403, SocialExportGetRudoFolders404 } from "../models/SocialExportGetRudoFolders";

export function getSocialExportGetRudoFoldersUrl(connectionId: SocialExportGetRudoFoldersPathParams["connectionId"]) {
  const res = { method: 'GET', url: `/social-export/v1/platforms/rudo/${connectionId}/folders` as const }
  return res
}

/**
 * @description Returns folders available on the connected Rudo account for selecting a publish destination.
 * @summary List Rudo folders for a connection
 * {@link /social-export/v1/platforms/rudo/:connectionId/folders}
 */
export async function socialExportGetRudoFolders(connectionId: SocialExportGetRudoFoldersPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<SocialExportGetRudoFoldersQueryResponse, ResponseErrorConfig<SocialExportGetRudoFolders400 | SocialExportGetRudoFolders401 | SocialExportGetRudoFolders403 | SocialExportGetRudoFolders404>, unknown>({ method : "GET", url : getSocialExportGetRudoFoldersUrl(connectionId).url.toString(), ... requestConfig })
  return res.data
}